/* eslint-disable no-nested-ternary */
import React, { PureComponent } from 'react';

import Link from 'Component/Link';
import {
    ACCOUNT_DOCUMENTS_URL,
    CANCELED_STATUSES,
    CUSTOMER_GROUP_LABELS, GROUP_ID_EMPLOYEE,
    GROUP_ID_PRO, GROUP_ID_STUDENT, PENDING_STATUSES,
    STATUS_ATTENTE, STATUS_ATTENTE_ETUDIANT,
    STATUS_ATTENTE_ETUDIANT_NO_DOC, STATUS_ATTENTE_NO_DOC,
    STATUS_ATTENTE_SALARIE, STATUS_ATTENTE_SALARIE_NO_DOC, STATUS_DESACTIVE, STATUS_DESACTIVE_ETUDIANT,
    STATUS_DESACTIVE_SALARIE,
    STATUS_REFUSE, STATUS_REFUSE_ETUDIANT, STATUS_REFUSE_SALARIE
} from 'Route/MyAccount/MyAccount.config';
import { CustomerType } from 'Type/Account.type';
import history from 'Util/History';

import './MyAccountStatusMessage.style';

/** @namespace PeggysagePwa/Component/MyAccountStatusMessage/Component */
export class MyAccountStatusMessageComponent extends PureComponent {
    static propTypes = {
        customer: CustomerType.isRequired
    };

    renderMessage(accountStatus) {
        const { location: { pathname } } = history;

        const isEditDocumentsPage = pathname.includes(ACCOUNT_DOCUMENTS_URL);

        const noDocText = isEditDocumentsPage
            ? __('Vous pouvez finaliser votre inscription en transmettant les justificatifs manquants ci-dessous.')
            : __('Vous pouvez finaliser votre inscription sur la page "%s" :', __('My documents'));

        switch (accountStatus) {
        case STATUS_ATTENTE:
            return (
                <>
                    <p>
                        { __('Votre compte pro est en attente de validation.') }
                    </p>
                    <p>
                        { __('Les demandes de comptes pro sont validées en 2 jours ouvrés maximum.') }
                    </p>
                    <p>
                        { __('En attendant la validation de votre compte vous pouvez passer une commande '
                            + 'mais vous ne bénéficierez pas des tarifs professionnels.') }
                    </p>
                </>
            );
        case STATUS_ATTENTE_ETUDIANT:
            return (
                <>
                    <p>
                        { __('Votre compte étudiant est en attente de validation.') }
                    </p>
                    <p>
                        { __('Les demandes de comptes étudiants sont validées en 2 jours ouvrés maximum.') }
                    </p>
                    <p>
                        { __('En attendant la validation de votre compte vous pouvez passer une commande '
                            + 'mais vous ne bénéficierez pas des tarifs étudiants.') }
                    </p>
                </>
            );
        case STATUS_ATTENTE_SALARIE:
            return (
                <>
            <p>
                { __('Votre compte salarié est en attente de validation.') }
            </p>
            <p>
                { __('Les demandes de comptes salarié sont validées en 2 jours ouvrés maximum.') }
            </p>
            <p>
                { __('En attendant la validation de votre compte vous pouvez passer une commande '
                    + 'mais vous ne bénéficierez pas des tarifs professionnels.') }
            </p>
                </>
            );
        case STATUS_ATTENTE_NO_DOC:
            return (
                <>
                    <p>
                        { __('Votre ouverture de compte pro sera examinée quand vous aurez transmis '
                            + 'les justificatifs manquants.') }
                    </p>
                    <p>
                        <strong>{ noDocText }</strong>
                        { !isEditDocumentsPage && (
                            <>
                                <br />
                                <Link to={ `${ ACCOUNT_DOCUMENTS_URL }` }>
                                    { __('Transmettre mes justificatifs') }
                                </Link>
                            </>
                        ) }
                    </p>
                    <p>
                        { __('En attendant la validation de votre compte vous pouvez passer une commande '
                            + 'mais vous ne bénéficierez pas des tarifs salarié.') }
                    </p>
                </>
            );
        case STATUS_ATTENTE_ETUDIANT_NO_DOC:
            return (
                <>
                    <p>
                        { __('Votre ouverture de compte étudiant sera examinée quand vous aurez transmis '
                            + 'les justificatifs manquants.') }
                    </p>
                    <p>
                        <strong>{ noDocText }</strong>
                        { !isEditDocumentsPage && (
                            <>
                                <br />
                                <Link to={ `${ ACCOUNT_DOCUMENTS_URL }` }>
                                    { __('Transmettre mes justificatifs') }
                                </Link>
                            </>
                        ) }
                    </p>
                    <p>
                        { __('En attendant la validation de votre compte vous pouvez passer une commande '
                            + 'mais vous ne bénéficierez pas des tarifs étudiants.') }
                    </p>
                </>
            );
        case STATUS_ATTENTE_SALARIE_NO_DOC:
            return (
                <>
                    <p>
                        { __('Votre ouverture de compte salarié sera examinée quand vous aurez transmis '
                            + 'les justificatifs manquants.') }
                    </p>
                    <p>
                        <strong>{ noDocText }</strong>
                        { !isEditDocumentsPage && (
                            <>
                                <br />
                                <Link to={ `${ ACCOUNT_DOCUMENTS_URL }` }>
                                    { __('Transmettre mes justificatifs') }
                                </Link>
                            </>
                        ) }
                    </p>
                    <p>
                        { __('En attendant la validation de votre compte vous pouvez passer une commande '
                            + 'mais vous ne bénéficierez pas des tarifs salarié.') }
                    </p>
                </>
            );
        case STATUS_REFUSE:
        case STATUS_REFUSE_ETUDIANT:
        case STATUS_REFUSE_SALARIE:
            return (
                <>
                    <p>
                        { __(
                            'Nous sommes au regret de vous annoncer que votre compte %s ne peut-être validé.',
                            STATUS_REFUSE_ETUDIANT === accountStatus
                                ? CUSTOMER_GROUP_LABELS[GROUP_ID_STUDENT]?.singular.toLowerCase() || ''
                                : STATUS_REFUSE_SALARIE === accountStatus
                                    ? CUSTOMER_GROUP_LABELS[GROUP_ID_EMPLOYEE]?.singular.toLowerCase() || ''
                                    : CUSTOMER_GROUP_LABELS[GROUP_ID_PRO]?.singular.toLowerCase() || ''
                        ) }
                    </p>
                    <p>
                        { __('Vous trouverez plus d\'informations sur le motif de ce refus dans le mail '
                            + 'que nous vous avons envoyé.') }
                    </p>
                    <p>
                        { __('N\'hésitez pas à contacter le service client si vous souhaitez faire une '
                            + 'nouvelle demande.') }
                    </p>
                </>
            );
        case STATUS_DESACTIVE:
        case STATUS_DESACTIVE_ETUDIANT:
        case STATUS_DESACTIVE_SALARIE:
            return (
                <>
                    <p>
                        { __(
                            'Nous sommes au regret de vous annoncer que votre compte %s a été désactivé.',
                            STATUS_DESACTIVE_ETUDIANT === accountStatus
                                ? CUSTOMER_GROUP_LABELS[GROUP_ID_STUDENT]?.singular.toLowerCase() || ''
                                : STATUS_DESACTIVE_SALARIE === accountStatus
                                    ? CUSTOMER_GROUP_LABELS[GROUP_ID_EMPLOYEE]?.singular.toLowerCase() || ''
                                    : CUSTOMER_GROUP_LABELS[GROUP_ID_PRO]?.singular.toLowerCase() || ''
                        ) }
                    </p>
                    <p>
                        { __('Vous trouverez plus d\'informations sur la raison de cette désactivation '
                            + 'dans le mail que nous vous avons envoyé.') }
                    </p>
                    <p>
                        { __('N\'hésitez pas à contacter le service client si vous avez des questions '
                            + 'concernant votre compte.') }
                    </p>
                </>
            );
        default:
            return null;
        }
    }

    render() {
        const { customer: { status_pro: accountStatus } } = this.props;

        if (!PENDING_STATUSES.includes(accountStatus) && !CANCELED_STATUSES.includes(accountStatus)) {
            return null;
        }

        const isStudent = [
            STATUS_ATTENTE_ETUDIANT,
            STATUS_ATTENTE_ETUDIANT_NO_DOC,
            STATUS_REFUSE_ETUDIANT,
            STATUS_DESACTIVE_ETUDIANT
        ].includes(accountStatus);

        const isPro = !isStudent;

        return (
            <div
              block="MyAccountStatusMessage"
              mods={ { isPro, isStudent } }
            >
                <div block="MyAccountStatusMessage" elem="Content">
                    { this.renderMessage(accountStatus) }
                </div>
            </div>
        );
    }
}

export default MyAccountStatusMessageComponent;
